import React from 'react';
import { Button } from '../ui';

const PROSPECTUS = [
    {
        title: 'Asset inventory',
        body: 'Property, accounts, investments, pensions, gifts, foreign assets, debts. We capture what matters and skip what doesn\'t.',
    },
    {
        title: 'Compliance check',
        body: 'Allowances and reliefs applied per IHTA 1984. RNRB taper, transferred NRB, spouse exemption, charity rate.',
    },
    {
        title: 'Inheritance tax calculation',
        body: 'A worked figure for the IHT due, deadlines, and the HMRC filing route — IHT400, IHT205 / 207, or excepted estate.',
    },
];

export const WelcomeStep: React.FC<{ onNext: () => void }> = ({ onNext }) => {
    return (
        <div className="max-w-[640px] mx-auto pt-4 pb-12">
            <div className="text-[10px] tracking-eyebrow uppercase text-accent font-semibold mb-6">
                For executors · England &amp; Wales
            </div>

            <h1 className="font-serif text-[38px] leading-[1.08] tracking-[-0.02em] text-ink mb-6">
                A guided review of the estate, before you file with HMRC.
            </h1>

            <p className="font-serif italic text-[16px] text-ink2 mb-12 leading-relaxed">
                Work through the estate at your own pace. Every answer is saved
                automatically — close the browser and resume when you're ready.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 border-t border-rule pt-8 mb-12">
                {PROSPECTUS.map((item, i) => (
                    <article key={item.title}>
                        <div className="font-serif italic text-[13px] text-accent mb-2">
                            {['I', 'II', 'III'][i]}.
                        </div>
                        <h3 className="font-serif text-[15px] text-ink mb-2">{item.title}</h3>
                        <p className="text-[12px] text-ink2 leading-relaxed">{item.body}</p>
                    </article>
                ))}
            </div>

            <div className="flex items-center gap-6">
                <Button variant="primary" iconTrailing="→" onClick={onNext}>
                    Begin the review
                </Button>
                <span className="text-[11px] text-ink3">
                    Saved locally · no data leaves your machine until you sign in.
                </span>
            </div>
        </div>
    );
};
